export type Workflow = "chat" | "ask_agent";

export interface WorkflowConfig {
  label: string;
  description: string;
}

export const WORKFLOW_CONFIG: Record<Workflow, WorkflowConfig> = {
  chat: {
    label: "Chat",
    description: "Product-specific support grounded in the DigitalPersona knowledge base",
  },
  ask_agent: {
    label: "Ask Agent",
    description:
      "General engineering/technical answers",
  },
};
